<script setup>
    defineProps({
        fields: Object,
    })
</script>

<template>
    <div class="section-text container m-5 mx-auto text-center">
        <img :src="fields.image.permalink" class="mx-auto max-w-full max-w-prose" />
    </div>
</template>
